/**
 * Sentry 初期化 (admin-web / Cloudflare Pages).
 *
 * PII は `sanitizeSentryEvent` で必ずマスクする。
 * DSN 未設定時は noop にする。
 */

import { sanitizeSentryEventPayload } from '@petacms/shared-utils/sentry';
import * as Sentry from '@sentry/browser';

const SENTRY_DSN =
  (import.meta as unknown as { env?: { VITE_SENTRY_DSN?: string } }).env?.VITE_SENTRY_DSN ?? '';

let initialized = false;

function resolveEnvironment(): string {
  if (typeof window === 'undefined') {
    return 'unknown';
  }

  const host = window.location.hostname;
  if (host === 'app.peta-cms.com') return 'production';
  if (host === 'staging-app.peta-cms.com') return 'staging';
  if (host === 'localhost' || host === '127.0.0.1') return 'local';
  if (host.endsWith('.pages.dev') || host.includes('preview')) return 'preview';

  return (import.meta as unknown as { env?: { MODE?: string } }).env?.MODE ?? 'unknown';
}

export function initSentry(): void {
  if (initialized || !SENTRY_DSN) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: resolveEnvironment(),
    sendDefaultPii: false,
    beforeSend: (event) => sanitizeSentryEventPayload(event),
  });

  initialized = true;
}

export function captureException(
  error: unknown,
  context?: Parameters<typeof Sentry.captureException>[1],
): void {
  if (!initialized || !SENTRY_DSN) return;
  Sentry.captureException(error, context);
}
